























































import { Component, Vue, Prop, Emit, Ref } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import BackofficeGlobalStore from '@/components/Backoffice/Store/BackofficeGlobalStore'
import { maskDate } from '@/utils/common'
import { Carater } from '@/types/interfaces/Solicitacao'

@Component
export default class ComponentBackofficeProtocoloOperadora extends Vue {
  @Prop({ required: false }) label
  @Prop({ required: false, default: false }) disabled: boolean

  protocoloOperadoraForm: any = {
    valid: true,
    protocoloOperadora: [
      v => !!v || 'Campo obrigatório.',
    ],
  }

  get getBackofficeGlobalStore() {
    return getModule(BackofficeGlobalStore, this.$store)
  }

  get hasOpme() {
    return this.getBackofficeGlobalStore.solicitacao.grupoOpmeDaSolicitacao && this.getBackofficeGlobalStore.solicitacao.grupoOpmeDaSolicitacao.length > 0
  }

  get getDataAutorizacao() {
    if (this.getBackofficeGlobalStore.solicitacao.autorizacaoValidade) {
      return maskDate(this.getBackofficeGlobalStore.solicitacao.autorizacaoValidade)
    }
    return ''
  }

  set getDataAutorizacao(value: string) {
    this.getBackofficeGlobalStore.setAutorizacaoValidade(value)
  }


  get surgerySolicitationHasUrgencyAutorizationEnabled() {
    return this.getBackofficeGlobalStore.solicitacao.utilizaAnalisePreAutorizacaoUrgencia
      && this.getBackofficeGlobalStore.solicitacao.utilizaAguardandoAutorizacaoUrgencia
      && this.surgeryType && this.surgeryType.key === 'Urgencia'
      && (this.surgeryStatus === 'AguardandoAutorizacaoUrgencia' || this.surgeryStatus === 'AnalisePreAutorizacaoUrgencia')
  }

  get surgeryType() {
    return this.getBackofficeGlobalStore.solicitacao.carater as Carater
  }

  get surgeryStatus() {
    return this.getBackofficeGlobalStore.solicitacao.situacao.key
  }
}
